import { render, staticRenderFns } from "./OverviewItem.vue?vue&type=template&id=9ab9a18a&scoped=true&"
import script from "./OverviewItem.vue?vue&type=script&lang=js&"
export * from "./OverviewItem.vue?vue&type=script&lang=js&"
import style0 from "./OverviewItem.vue?vue&type=style&index=0&id=9ab9a18a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ab9a18a",
  null
  
)

export default component.exports